import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const headers = () => ({ 'x-admin-token': sessionStorage.getItem('ml_admin_token') || '' });

export const adminApi = {
  metrics: () => axios.get(`${API}/admin/daas/metrics`, { headers: headers() }).then((r) => r.data),
  projects: (accountEmail) => axios.get(`${API}/admin/daas/projects${accountEmail ? `?account_email=${encodeURIComponent(accountEmail)}` : ''}`, { headers: headers() }).then((r) => r.data),
  projectFull: (id) => axios.get(`${API}/admin/daas/projects/${id}/full`, { headers: headers() }).then((r) => r.data),
  transition: (id, to_state) => axios.post(`${API}/admin/daas/projects/${id}/transition`, { to_state }, { headers: headers() }).then((r) => r.data),
  submitScope: (id, body) => axios.post(`${API}/admin/daas/projects/${id}/scope/submit`, body, { headers: headers() }).then((r) => r.data),
  sendAgreement: (id, body) => axios.post(`${API}/admin/daas/projects/${id}/agreement`, body || {}, { headers: headers() }).then((r) => r.data),
  createSubscription: (id, body) => axios.post(`${API}/admin/daas/projects/${id}/subscription`, body, { headers: headers() }).then((r) => r.data),
  createMilestone: (id, body) => axios.post(`${API}/admin/daas/projects/${id}/milestones`, body, { headers: headers() }).then((r) => r.data),
  updateMilestone: (mid, body) => axios.patch(`${API}/admin/daas/milestones/${mid}`, body, { headers: headers() }).then((r) => r.data),
  createDeliverable: (id, body) => axios.post(`${API}/admin/daas/projects/${id}/deliverables`, body, { headers: headers() }).then((r) => r.data),
  postMessage: (id, text) => axios.post(`${API}/admin/daas/projects/${id}/messages`, { text }, { headers: headers() }).then((r) => r.data),
  updateAddon: (aid, status) => axios.patch(`${API}/admin/daas/addons/${aid}`, { status }, { headers: headers() }).then((r) => r.data),
  // ── Phase 4 billing ──
  generateInvoice: (subId, body) => axios.post(`${API}/admin/daas/subscriptions/${subId}/invoice`, body || {}, { headers: headers() }).then((r) => r.data),
  activateSubscription: (subId) => axios.post(`${API}/admin/daas/subscriptions/${subId}/activate`, {}, { headers: headers() }).then((r) => r.data),
  billAddon: (addonId, body) => axios.post(`${API}/admin/daas/addons/${addonId}/bill`, body || {}, { headers: headers() }).then((r) => r.data),
  billingDue: () => axios.get(`${API}/admin/daas/billing/due`, { headers: headers() }).then((r) => r.data),
  readiness: () => axios.get(`${API}/billing/readiness`).then((r) => r.data),
  invoicePayLink: (invoiceId) => axios.post(`${API}/invoices/${invoiceId}/pay-online`).then((r) => r.data),
  // CRM
  crmLeads: () => axios.get(`${API}/admin/crm/leads`, { headers: headers() }).then((r) => r.data),
  leadStage: (id, stage) => axios.patch(`${API}/admin/leads/${id}/stage`, { stage }, { headers: headers() }).then((r) => r.data),
  leadNote: (id, text) => axios.post(`${API}/admin/leads/${id}/note`, { text }, { headers: headers() }).then((r) => r.data),
  convertLead: (id, body) => axios.post(`${API}/admin/leads/${id}/convert`, body || {}, { headers: headers() }).then((r) => r.data),
};

/* Lifecycle vocabulary shared with backend (display + valid transitions). */
export const STATE_LABELS = {
  draft: 'Getting started', requirements_submitted: 'Requirements submitted', scoping: 'Scope in review',
  scope_approved: 'Scope approved', agreement_pending: 'Agreement sent', agreement_accepted: 'Awaiting payment',
  subscribed: 'Subscribed', onboarding: 'Onboarding', in_development: 'In development', launched: 'Launched',
  ongoing: 'Active & managed', paused: 'Paused', cancelled: 'Cancelled', legacy: 'Legacy',
};

export const TRANSITIONS = {
  draft: ['requirements_submitted', 'cancelled'],
  requirements_submitted: ['scoping', 'cancelled'],
  scoping: ['scope_approved', 'requirements_submitted', 'cancelled'],
  scope_approved: ['agreement_pending', 'scoping', 'cancelled'],
  agreement_pending: ['agreement_accepted', 'scope_approved', 'cancelled'],
  agreement_accepted: ['subscribed', 'cancelled'],
  subscribed: ['onboarding', 'paused', 'cancelled'],
  onboarding: ['in_development', 'paused', 'cancelled'],
  in_development: ['launched', 'paused', 'cancelled'],
  launched: ['ongoing', 'paused', 'cancelled'],
  ongoing: ['paused', 'cancelled'],
  paused: ['ongoing', 'in_development', 'cancelled'],
  cancelled: [],
  legacy: ['ongoing', 'cancelled'],
};

export const LEAD_STAGES = ['new', 'contacted', 'qualified', 'discovery', 'scope_review', 'proposal', 'won', 'onboarding', 'active_client'];
export const LEAD_STAGE_LABELS = {
  new: 'New', contacted: 'Contacted', qualified: 'Qualified', discovery: 'Discovery',
  scope_review: 'Scope Review', proposal: 'Proposal', won: 'Won', onboarding: 'Onboarding', active_client: 'Active Client',
};
